module.exports = __webpack_public_path__ + "img/phone8.cc5e6253.png";